import request from '@/utils/request'

// 获取微信code
export function getCode(data) {
  return request({
    url: 'wechat/Base/WxUserAuthorize',
    method: 'get',
    params: data
  })
}

// 获取openid/token
export function getToken(data) {
  return request({
    url: 'wechat/Base/WxUserInfo',
    method: 'get',
    params: data
  })
}

// 获取规格
export function getSpecList(data) {
  return request({
    url: 'index/goods/speclist',
    method: 'get',
    params: data
  })
}

// 获取商品
export function getGoodsList(data) {
  return request({
    url: 'index/goods/list',
    method: 'get',
    params: data
  })
}

// 获取订单记录
export function checkUserOrder(data) {
  return request({
    url: 'index/Order/userOrder',
    method: 'post',
    data: data
  })
}

// 订单支付
export function userPay(data) {
  return request({
    url: 'index/Order/userPay',
    method: 'post',
    data: data
  })
}
